module.exports = __webpack_public_path__ + "static/media/menu-icon.1fbe49eb.svg";